'use strict';

class TimelineController {

  constructor($scope, DataService, Datetime, Message, $log, Util, Storage) {
    'ngInject';
    this.$scope = $scope;
    this.DataService = DataService;
    this.Datetime = Datetime;
    this.Message = Message;
    this.$log = $log;
    this.Util = Util;
    this.Storage = Storage;

  }

  $onInit() {

    this.$log.log("Componente timeline*******************");
    if (!this.ngModel) {
      this.ngModel = {};
    }
  }

}

export default TimelineController;



// WEBPACK FOOTER //
// ./src/app/common/core/util/page-timeline/pageTimeline.controller.js